import { apiRequest } from '@/core';
import { type User } from '@/types';

export const updateUserRequest = async (user: Partial<User>) =>
  apiRequest<User>({
    endpoint: 'api/user',
    method: 'PATCH',
    body: user,
  });
